import { filter, map, isNilOrEmpty } from '@neo/ramda-extra'
import { APP_SERVICES } from '@vega/constants'
import { USER_ROLES } from '@neo/constants'

const {
  LENDING_ADMIN,
  CREDIT_ASSESSOR,
  SUPER_ADMIN,
  BANKING_ADMIN,
  BANKING_CLIENT,
  LEAD_ASSESSOR,
  TREASURY_ADMIN,
} = USER_ROLES

const {
  VEGA_LEND_ADMIN,
  VEGA_LOAN_ORIGINATION,
  VEGA_BANKING_ADMIN,
  VEGA_BANKING_CUSTOMER,
  VEGA_TREASURY_MANAGEMENT,
  VEGA_APPLY_ONLINE_ADMIN,
  VEGA_APPLY_ONLINE_CUSTOMER,
} = APP_SERVICES

const appServiceACL = [
  {
    role: LENDING_ADMIN,
    app: VEGA_LEND_ADMIN,
  },
  {
    role: CREDIT_ASSESSOR || LEAD_ASSESSOR,
    app: VEGA_LOAN_ORIGINATION,
  },

  {
    role: BANKING_CLIENT,
    app: VEGA_BANKING_CUSTOMER,
  },
  {
    role: BANKING_ADMIN,
    app: VEGA_BANKING_ADMIN,
  },
  {
    role: TREASURY_ADMIN,
    app: VEGA_TREASURY_MANAGEMENT,
  },

  {
    role: SUPER_ADMIN,
    app: VEGA_APPLY_ONLINE_ADMIN,
  },
  {
    role: SUPER_ADMIN,
    app: VEGA_APPLY_ONLINE_CUSTOMER,
  },
]

const getAuthorisedAppKeys = map((acl) => acl.app)

const getAllAppsKeys = () => getAuthorisedAppKeys(appServiceACL)

export default (usersRoles) => {
  if (isNilOrEmpty(usersRoles)) return []

  if (usersRoles.includes(SUPER_ADMIN)) return getAllAppsKeys()

  const filterUnauthorisedApps = (ac) => usersRoles.includes(ac.role)
  const authorisedApps = filter(filterUnauthorisedApps, appServiceACL)

  return getAuthorisedAppKeys(authorisedApps)
}
